import Vue from 'vue'

export default {
  setCarWashDisputes: (state, value) => {
    state.carWashDisputes = value
  },
  setDisputes: (state, value) => {
    state.disputes = value
  },
  setSelectedDispute: (state, value) => {
    state.selectedDispute = value
  },
  setSelectedDisputeValue: (state, data) => {
    Vue.set(state.selectedDispute, data.key, data.value)
  },
  setDisputeInDisputesArray: (state, payload) => {
    // eslint-disable-next-line no-console
    console.log('setDisputeInDisputesArray')
    if (state.disputes && state.disputes.length > 0) {
      const existingDispute = state.disputes.find(dispute => {
        return dispute.ID === payload.ID
      })
      // eslint-disable-next-line no-console
      console.log(existingDispute)
      Object.assign(existingDispute, payload)
    }
  },
  setCurrentPageNumber: (state, value) => {
    state.currentPageNumber = value
  },
  setPageSize: (state, value) => {
    state.pageSize = value
  },
  setNextAvailablePage: (state, value) => {
    state.nextAvailablePage = value
  }
}
